import { render } from "./ModalDocumentUploadName.vue?vue&type=template&id=4fb36f2b&scoped=true"
import script from "./ModalDocumentUploadName.vue?vue&type=script&lang=js"
export * from "./ModalDocumentUploadName.vue?vue&type=script&lang=js"

import "./ModalDocumentUploadName.vue?vue&type=style&index=0&id=4fb36f2b&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Tomi\\PhpstormProjects\\frontend-v2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fb36f2b"]])

export default __exports__